<template>
    <div uk-sticky="top: 150000px">
        <div class="uk-visible@l" >
            <div >
                <nav class="uk-navbar-container uk-margin uk-margin-remove-bottom" uk-navbar="mode: click; target: !.uk-navbar; align: center" >
                    <div class="uk-navbar-left">

                        <router-link class="uk-navbar-item uk-logo" to="/">
                            <img src="../../../public/fincor_black1.png" class="logoStyle" alt="">
                        </router-link>

                    </div>
                    <div class="uk-navbar-right" style="padding-right: 15px;">
                        <ul class="uk-navbar-nav">
                            <li><router-link to="/" class="uk-text-capitalize">Home</router-link></li>
                            <li >
                                <a href="#" class="uk-text-capitalize">Industries</a>
                                <div class="uk-navbar-dropdown  uk-navbar-dropdown-width-2" style="margin-top: -15px">
                                    <ul class="uk-nav uk-navbar-dropdown-nav">
                                        <li ><router-link to="/public-sector-financial-services">Public Sector</router-link></li>
                                        <li><router-link to="/private-business-and-individual-financial-services">Private Businesses and individuals</router-link></li>
                                        <li><router-link to="/charities-and-non-profit-financial-services">Charities and Non-Profits</router-link></li>
                                    </ul>
                                </div>
                            </li>
                            <li >
                                <a href="#" class="uk-text-capitalize">Services</a>
                                <div class="uk-navbar-dropdown  uk-navbar-dropdown-width-2" style="margin-top: -15px">
                                    <ul class="uk-nav uk-navbar-dropdown-nav">
                                        <li><router-link to="/accountant-reviews-financial-services" >Accountant Reviews </router-link></li>
                                        <li><router-link to="/accounting-services" >Accounting Services </router-link></li>
                                        <li><router-link to="/board-governance-and-support" >Board Governance and Support</router-link></li>
                                        <li ><router-link to="/compliance-monitoring-services">Compliance Monitoring  </router-link></li>
                                        <li ><router-link to="/financial-advisory-services">Financial Advisory </router-link></li>

                                        <li><router-link to="/financial-management-services">Financial Management</router-link></li>
                                        <li><router-link to="/financial-reporting-services">Financial Reporting</router-link></li>
                                    </ul>
                                </div>
                            </li>
                            <li><router-link to="/testimonials" class="uk-text-capitalize">Testimonials</router-link></li>
                            <li><router-link to="/blogs" class="uk-text-capitalize">Blogs</router-link></li>


                            <li >
                                <a href="#" class="uk-text-capitalize">About Us</a>
                                <div class="uk-navbar-dropdown" style="margin-top: -15px">
                                    <ul class="uk-nav uk-navbar-dropdown-nav">
                                        <li ><router-link to="/why-choose-fincor-services">Why Fincor?</router-link></li>
                                        <li><router-link to="/our-management-team">Management Team</router-link></li>
                                        <!--<li><router-link to="/coreValues">Core Values, Vision & Mission Statements</router-link></li>-->
                                    </ul>
                                </div>
                            </li>
                            <li><router-link class="uk-text-capitalize" to="/contact-us"  >Contact Us</router-link>
                            </li>
                            <li>
                                <a class="uk-button uk-button-default uk-text-capitalize" style="min-height: 40px; margin-top: 20px; color: rgb(197,179,88); border: 1px solid rgb(197,179,88);" href="#">Client Login</a>
                                <div uk-dropdown="mode: click;">
                                    <ul class="uk-nav uk-dropdown-nav">
                                        <li ><a href="https://myaccount.rightnetworks.com/#/login" target="_blank">Right Networks</a></li>
                                        <li><a href="https://my.smartvault.com/secure/SignIn.aspx" target="_blank">Client Documents</a></li>

                                    </ul>
                                </div>
                            </li>
                        </ul>


                    </div>
                </nav>
            </div>
            <div id="mother" style="border-bottom: 2px rgb(197,179,88) solid;">

                <div  uk-grid style="background: #111;">
                    <div class="uk-width-expand" style="background: #111; padding-right: 80px; padding-top: 5px; padding-bottom: 5px;">
                        <p style="padding-left: 15px; color: rgb(197,179,88)">"Delivering value for money through a client focused approach"</p>
                    </div>
                    <div class="uk-width-auto"  style="background: #111; padding-right: 80px; padding-top: 5px; padding-bottom: 5px;">
                        <span uk-icon="icon: receiver" style="padding-left: 15px; color: rgb(197,179,88)"></span>
                        <a href="tel:1345-746-9272" style="font-size: 16px; color: rgba(197, 179, 88, 0.8);"> 1345-746-9272 (345-74MYCPA)</a>
                        <span uk-icon="icon: mail" style="padding-left: 30px; color: rgb(197,179,88)"></span>
                        <a style="font-size: 16px; color: rgba(197, 179, 88, 0.8);" href="mailto:admin@fincor.ky">admin@fincor.ky</a>
                        <a style="padding-left: 5px; padding-right: 5px;" href="https://www.facebook.com/fincorcayman/?hc_ref=SEARCH&amp;fref=nf" target="_blank"><i class="fa fa-facebook" aria-hidden="true"></i></a>
                        <a href="https://www.instagram.com/fincor_cayman/" style="padding-left: 10px; padding-right: 5px;" target="_blank"><i class="fa fa-instagram" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="uk-hidden@l">
            <nav class="uk-navbar uk-navbar-container uk-margin">
                <div class="uk-navbar-left">
                    <router-link class="uk-navbar-item uk-logo" to="/">
                        <img src="../../../public/fincor_black1.png" class="logoStyle" alt="">
                    </router-link>
                </div>
                <div class="uk-navbar-right" style="padding-right: 15px;">
                    <a class="uk-navbar-toggle" uk-navbar-toggle-icon href="#" uk-toggle="target: #offcanvas-overlay"></a>

                </div>
            </nav>
            <div id="offcanvas-overlay" uk-offcanvas="overlay: true">
                <div class="uk-offcanvas-bar" style="background: black; border-right: 2px solid rgb(197,179,88)">
                    <div>
                        <a href="#">
                            <img src="../../../public/fincor_black1.jpg" alt="">
                        </a>
                    </div>

                    <div>
                        <br>
                        <ul class="uk-nav-default uk-nav-parent-icon" uk-nav>
                            <li class="uk-active"><router-link to="/" class="uk-text-capitalize" @click.native="closeOffCanvas()">Home</router-link></li>
                            <li class="uk-parent">
                                <a href="#">Industries</a>
                                <ul class="uk-nav-sub">
                                    <li><router-link to="/public-sector-financial-services" @click.native="closeOffCanvas()">Public Sector</router-link></li>
                                    <li><router-link to="/private-business-and-individual-financial-services" @click.native="closeOffCanvas()">Private Businesses and individuals</router-link></li>
                                    <li><router-link to="/charities-and-non-profit-financial-services" @click.native="closeOffCanvas()">Charities and Non-Profits</router-link></li>
                                </ul>
                            </li>
                            <li class="uk-parent">
                                <a href="#">Services</a>
                                <ul class="uk-nav-sub">
                                    <li><router-link to="/accountant-reviews-financial-services" @click.native="closeOffCanvas()">Accountant Reviews</router-link></li>
                                    <li><router-link to="/accounting-services" @click.native="closeOffCanvas()">Accounting Services</router-link></li>
                                    <li><router-link to="/board-governance-and-support" @click.native="closeOffCanvas()">Board Governance and Support</router-link></li>
                                    <li><router-link to="/compliance-monitoring-services" @click.native="closeOffCanvas()">Compliance Monitoring</router-link></li>
                                    <li><router-link to="/financial-advisory-services" @click.native="closeOffCanvas()">Financial Advisory</router-link></li>

                                    <li><router-link to="/financial-management-services" @click.native="closeOffCanvas()">Financial Management</router-link></li>
                                    <li><router-link to="/financial-reporting-services" @click.native="closeOffCanvas()">Financial Reporting</router-link></li>
                                </ul>
                            </li>

                            <li><router-link to="/testimonials" class="uk-text-capitalize" @click.native="closeOffCanvas()">Testimonials</router-link></li>
                            <!--<li><router-link to="/vlogs" class="uk-text-capitalize">Vlog</router-link></li>-->
                            <li class="uk-nav-divider"></li>
                            <li class="uk-parent">
                                <a href="#">About us</a>
                                <ul class="uk-nav-sub">
                                    <li><router-link to="/why-choose-fincor-services" @click.native="closeOffCanvas()">Why Fincor?</router-link></li>
                                    <li><router-link to="/our-management-team" @click.native="closeOffCanvas()">Management Team</router-link></li>
                                    <!--<li><router-link to="/coreValues">Core Values, Vision & Mission Statements</router-link></li>-->
                                </ul>
                            </li>
                            <li><router-link class="uk-text-capitalize" to="/contact-us"  @click.native="closeOffCanvas()">Contact Us</router-link>
                            </li>
                            <li class="uk-parent">
                                <a href="#">Login</a>
                                <ul class="uk-nav-sub">
                                    <li ><a href="https://myaccount.rightnetworks.com/#/login" target="_blank">Right Networks</a></li>
                                    <li><a href="https://my.smartvault.com/secure/SignIn.aspx" target="_blank">Client Documents</a></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UIkit from 'uikit'
    export default {
        name: "navbar",
        methods: {
            closeOffCanvas: function () {
                //UIkit.offcanvas('#offcanvas-usage').hide();
                //alert('blue ball')
                UIkit.offcanvas("#offcanvas-overlay").hide();
                window.scrollTo(0, 0);
            }
        },
    }
</script>

<style scoped>
    /* Custom, iPhone Retina */
    @media only screen and (min-width : 320px) {
        nav{
            background: black !important;
            border-bottom: 1px rgb(197,179,88) solid;
        }
        .logoStyle{
            max-height: 250px;
            max-width: 250px;
            width: auto;
            height: auto;
            padding: 5px;
        }
        .uk-navbar-nav > li > a {
            font-size: 12pt;
            color: white;
            font-family: 'Alegreya Sans SC';
        }
        .uk-navbar-dropdown-nav > li > a{
          color: black;
          font-weight: 600;
        }
    }

    /* Extra Small Devices, Phones */
    @media only screen and (min-width : 480px) {
        .logoStyle{
            max-height: 150px;
            max-width: 150px;
            width: auto;
            height: auto;
            padding: 5px;
        }
    }

    /* Small Devices, Tablets */
    @media only screen and (min-width : 768px) {
        .logoStyle{
            max-height: 250px;
            max-width: 250px;
            width: auto;
            height: auto;
            padding: 5px;
        }
    }

    /* Medium Devices, Desktops */
    @media only screen and (min-width : 992px) {
        .logoStyle{
            max-height: 300px;
            max-width: 300px;
            width: auto;
            height: auto;
            padding: 5px;
        }
    }

    /* Large Devices, Wide Screens */
    @media only screen and (min-width : 1200px) {
        .logoStyle{
            max-height: 350px;
            max-width: 350px;
            width: auto;
            height: auto;
            padding: 5px;
        }
    }
    @media only screen and (min-width : 1440px) {
        .logoStyle{
            max-height: 400px;
            max-width: 400px;
            width: auto;
            height: auto;
            padding: 5px;
        }

    }
    @media only screen and (min-width : 1600px) {


    }

</style>